// Shared visual per event type (Accueil agenda, Coaching calendar and consultations, Community live posts, event details).
// One illustration per type, no portrait: the same event reads the same everywhere. Files live next to index.html (./assets).
export type EventVisualType = "tg" | "consult" | "live" | "atelier" | "tour";

const EVENT_VISUALS: Record<EventVisualType, string> = {
  tg: "./assets/tc-da-genius-0810.png",
  consult: "./assets/tc-da-consult-0810.png",
  live: "./assets/tc-da-live-0810.png",
  atelier: "./assets/tc-da-atelier-0810.png",
  tour: "./assets/tc-da-tour-0810.png",
};

export function eventVisual(type: EventVisualType): string {
  return EVENT_VISUALS[type];
}
